import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { CardActionArea } from '@mui/material';

interface AssessmentCardProps {
    assessmentId: number;
    assessmentTitle: string;
    assessmentDescription: string;
    onSelect: (assessmentId: number) => void;
    isSelected: boolean;
}

interface ExpandMoreProps {
    expand: boolean;
    onClick: () => void;
}


const ExpandMore = styled(({ expand, ...other }: ExpandMoreProps & { children?: React.ReactNode }) => (
    <IconButton {...other} />
))(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const AssessmentCard: React.FC<AssessmentCardProps> = ({
    assessmentTitle,
    assessmentDescription,
    assessmentId,
    onSelect,
    isSelected,
}) => {
    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = () => {
        setExpanded((prevExpanded) => !prevExpanded);
    };


    const handleCardClick = () => {
        onSelect(assessmentId);
    };

    return (
        <Card
            sx={{
                mb: 4,
                boxShadow: isSelected ? 3 : 1,
                borderColor: isSelected ? 'var(--ttg-green)' : 'transparent',
                borderWidth: isSelected ? 2 : 1,
                borderStyle: 'solid',
            }}
            onClick={handleCardClick}
        >
            <CardActionArea>
                <CardContent>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={8}>
                            <Typography sx={{ textAlign: 'left', fontWeight: 'bold' }}>
                                {assessmentTitle}
                            </Typography>
                        </Grid>
                        <Grid item xs={4} container justifyContent="flex-end">
                            <IconButton
                                onClick={(event: React.MouseEvent<HTMLElement>) => {
                                    event.stopPropagation();
                                    setExpanded((prevExpanded) => !prevExpanded);
                                }}
                                aria-expanded={expanded}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </IconButton>

                        </Grid>
                    </Grid>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                        <Typography paragraph sx={{ mt: 2, textAlign: 'left' }}>
                            {assessmentDescription}
                        </Typography>
                    </Collapse>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default AssessmentCard;
export { AssessmentCardProps };
